export const APP_ENV = process.env.APP_ENV
export const APP_VERSION = process.env.npm_package_version

export const LS_APP_DOMAIN = {
  dev: 'http://localhost:3000',
  test: 'https://test.livinglife.com.tw',
  beta: 'https://beta.livinglife.com.tw',
  prod: 'https://livinglife.com.tw',
}[APP_ENV]

export const LS_API_DOMAIN = {
  dev: 'https://api-test.livinglife.com.tw',
  test: 'https://api-test.livinglife.com.tw',
  beta: 'https://api-beta.livinglife.com.tw',
  prod: 'https://api.livinglife.com.tw',
}[APP_ENV]

export const ADMIN_DOMAIN = {
  dev: 'https://admin-test.livinglife.com.tw/',
  test: 'https://admin-test.livinglife.com.tw/',
  beta: 'https://admin-beta.livinglife.com.tw/',
  prod: 'https://admin.livinglife.com.tw/',
}[APP_ENV]

export const LINEBOT_CHANNEL_ID = '1656258631'

export const RATING_URL_TEMPLATE = {
  dev:
    'https://docs.google.com/forms/d/e/1FAIpQLSda1o6U32jAEgo2Pqb84sTPCvqejNlw6vJW6MpS2OXpmIDIgg/viewform?usp=pp_url&entry.766348850=<%= reservationNo %>&entry.1918981803=<%= name %>&entry.2012362708=<%= phone %>&entry.1014708537=<%= address %>',
  test:
    'https://docs.google.com/forms/d/e/1FAIpQLSda1o6U32jAEgo2Pqb84sTPCvqejNlw6vJW6MpS2OXpmIDIgg/viewform?usp=pp_url&entry.766348850=<%= reservationNo %>&entry.1918981803=<%= name %>&entry.2012362708=<%= phone %>&entry.1014708537=<%= address %>',
  beta:
    'https://docs.google.com/forms/d/e/1FAIpQLSfU7k38mGo27TUl-BtXw8uqO9_DTvwgu-0aUOHJHP7M1ghsew/viewform?usp=pp_url&entry.1420267571=<%= reservationNo %>&entry.1918981803=<%= name %>&entry.2012362708=<%= phone %>&entry.1014708537=<%= address %>',
  prod:
    'https://docs.google.com/forms/d/e/1FAIpQLSfQwD7iSY23WJQrwalWDDFL1M5SeNg7O9pIgyTAR07OtBj1QA/viewform?usp=pp_url&entry.1550396156=<%= reservationNo %>&entry.992554503=<%= name %>&entry.1605758968=<%= phone %>&entry.1220635224=<%= address %>',
}[APP_ENV]

export const GOOGLE_TAG_MANAGER_KEY = 'GTM-KDH28B'
export const GTM_DEFAULT_DATA_LAYER = 'dataLayer'

export const GOOGLE_OPTIMIZE_KEY = 'OPT-T6C7NLQ'

export const FB_TRACKING_APP_ID = {
  dev: '398397272387069',
  test: '398397272387069',
  beta: '398397272387069',
  prod: '872777387016646',
}[APP_ENV]

export const FB_APP_ID = {
  dev: '398397272387069',
  test: '398397272387069',
  beta: '398397272387069',
  prod: '872777387016646',
}[APP_ENV]

export const SINYI_SID_DOMAIN = {
  dev: 'https://www-demo3.sinyi.com.tw/sidredirect/index.php',
  test: 'https://www-demo3.sinyi.com.tw/sidredirect/index.php',
  beta: 'https://www-demo3.sinyi.com.tw/sidredirect/index.php',
  prod: 'https://www.sinyi.com.tw/sidredirect/index.php',
}[APP_ENV]

export const RESERVATION_REVIEW_URL = 'https://form.jotform.com/222142612907449'
export const UNORDERED_RESERVATION_REVIEW_URL =
  'https://form.jotform.com/222212686584459'

export const LS_TERMS_OF_SERVICE_LINK = 'https://link.livinglife.com.tw/dFWsDf'
export const LS_PRIVACY_POLICY_LINK = 'https://link.livinglife.com.tw/MFsbt5'

export const SINYI_TERMS_OF_SERVICE_LINK = 'https://www.sinyi.com.tw/tos'
export const SINYI_PRIVACY_POLICY_LINK = 'https://www.sinyi.com.tw/privacy'

const firebaseForLogSetting = {
  dev: {
    apiKey: 'AIzaSyAuOBnmClmZvVYEuGHymF2b2Cn4cYc97n8',
    authDomain: 'sy-living-dev.firebaseapp.com',
    projectId: 'sy-living-dev',
    storageBucket: 'sy-living-dev.appspot.com',
    messagingSenderId: '991230004277',
    appId: '1:991230004277:web:27ea1d842a58e6fb47b57c',
    measurementId: 'G-3RX0440Z6H',
  },
  prod: {
    apiKey: 'AIzaSyCR0C5glhHE2GW_zBZg9VpTYm6PtZ9d6vE',
    authDomain: 'sy-living.firebaseapp.com',
    projectId: 'sy-living',
    storageBucket: 'sy-living.appspot.com',
    messagingSenderId: '203566467425',
    appId: '1:203566467425:web:3d179577c5b162940ddd20',
    measurementId: 'G-7K4K29VSHD',
  },
}

export const FIREBASE_FOR_LOG_SETTING = {
  dev: firebaseForLogSetting.dev,
  test: firebaseForLogSetting.dev,
  beta: firebaseForLogSetting.dev,
  prod: firebaseForLogSetting.prod,
}[APP_ENV]

// user-agent 白名單，跳過信義 sid 取得
export const USER_AGENT_BOT_LIST = [
  'Baiduspider-render', // 百度搜尋引擎
  'Googlebot', // Google 搜尋引擎
  'mappydata', // 日本 mappy 搜尋引擎
  'Yandex', // Yandex 搜尋引擎
  'WhatsApp', // WhatsApp
  'AdsBot-Google', // Google Ads bot
  'bingbot', // bing 搜尋引擎
  'msnbot', // msn 搜尋引擎
  'Yahoo! Slurp', // Yahoo 搜尋引擎
  'iasksspider', // sina 搜尋引擎
  'YoudaoBot', // 網易有道搜尋引擎
  'Sosospider', // 搜搜 搜尋引擎
  'Sogou', // 搜狗 搜尋引擎
  'Google-InspectionTool', // Google 檢索器和擷取程式
]
